/**
 * 查看投票结果
 */

import router from "@/router/index";
import { Dialog } from 'vant';

export default {
  methods: {
    async toResult() {
      if (!this.isWeixin) {
        await this.authGateLaunch()
      }

      const vote = this.vote;
      const isGod = vote.showDev || vote.is_vip;
      const vid = vote.vid || this.vid;
      const isRequester = vote.owner && vote.owner.is_requester || false;

      const canNavigate = (() => {
        if (isGod || isRequester) return true;

        // ['投票后立即可见', '投票截止/结束后可见', '仅发起者（我）可见', '投票前可见']
        switch (vote.hide_result) {
          case 0:
            return vote.is_vote || vote.is_end;
          case 1:
            return vote.is_end;
          case 2:
            return false; // 已在外层判断，此处仅为兜底
          case 3:
            return true;
          default:
            console.error('未知的hide_result:', vote.hide_result);
            return false;
        }
      })();

      if (canNavigate) {
        router.push({
          path: "/result",
          query: { vid, type: vote.type}
        });
      } else {
        const messages = [
          '需要先投票，才能查看实时结果哦~',
          `投票结果将在活动结束后公布\n时间：${vote.end_date}`,
          '投票结果仅发起人可见',
          ''
        ];
        const content = messages[vote.hide_result] || '结果暂不可见';
        Dialog.alert({
          message: content,
          confirmButtonText: '我知道了'
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/result.js